import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ArrivingFailed } from "@/client/components/arriving-layout";
import { BootPending } from "@/client/components/route-states";
import { requireSignedIn } from "@/client/lib/session";

/** The guard runs before any child's loader, so no child repeats the signed-in check. */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ context, location }) =>
    requireSignedIn(context.queryClient, location.href),
  // No shell before the session is read: the icon while it is, the arriving card if it fails.
  pendingComponent: BootPending,
  errorComponent: ArrivingFailed,
  component: Outlet,
});
